import { createAsyncAtom } from '../../lib';

const walletPopupOpenAtom = createAsyncAtom(async () => false);

export default walletPopupOpenAtom;
